module.exports = __webpack_public_path__ + "static/media/daily_calendar_cfc.85f14ed9.svg";